export enum SignOrderStatus {
  NOT_CREATED = "NOT_CREATED",
  CREATED = "CREATED",
  PENDING = "PENDING",
  CUSTOMER_SIGNED = "CUSTOMER_SIGNED",
  SIGNING_CONFIRMED = "SIGNING_CONFIRMED",
}

export interface SignOrderResponse {
  orderId: string;
  signingReference: string;
  signingUrl: string;
  status: SignOrderStatus;
  edhSigningReference?: string;
}
